module.exports = __webpack_public_path__ + "media/icon/icon-delete-bin-02aabdf5.svg";